<div class="field">
  <div *ngIf="label">
    <label
      class="bold"
      [id]="'lbl' + question_id"
      for="{{ question_id }}"
      [attr.aria-label]="label"
      style="display: inline"
      [attr.aria-hidden]="displayHelpText"
    >
      <span [hidden]="hide_label">{{ label }}</span>
      <div class="label-spacer-med"></div>
    </label>
    <button
      tabindex="-1"
      aria-pressed="false"
      type="button"
      class="help"
      title="more info"
      *ngIf="displayHelpText"
      placement="top-left"
      [attr.aria-label]="label"
      ngbPopover="{{ help_text }}"
      popoverTitle="More Info:"
    >
      ?
    </button>
  </div>
  <div class="" *ngIf="isInvalid">
    <p [class.error]="isInvalid">{{ error_text }}</p>
  </div>
  <div [formGroup]="paramFormGroup" class="input-spacer">
    <span class="optional-text" *ngIf="!required">(Optional)</span>
    <div *ngIf="readOnly; else editMode">
      <label>{{ getCurrentChoice() }}</label>
    </div>
    <ng-template #editMode>
      <mat-form-field
        [id]="isInvalid ? 'invalid' : ''"
        type="dropdown"
        disableOptionCentering="true"
        *ngIf="inputControl !== null"
      >
        <mat-select
          #input
          type="dropdown"
          [multiple]="multiple"
          [attr.id]="question_id"
          [id]="question_id"
          [formControl]="inputControl"
          class="focusInput"
          placeholder= '{{placeholder === null ? "Select" : placeholder}}'
          hideSingleSelectionIndicator
          [attr.aria-label]="getAriaLabel()"
        >
          <mat-option *ngFor="let option of choices" [value]="option.id">{{ choiceText(option) }}</mat-option>
        </mat-select>

        <mat-placeholder></mat-placeholder>
      </mat-form-field>
    </ng-template>
  </div>
</div>
